(function () {
  "use strict";

  brandModel.$inject = ['bodyColorOptions'];
  angular
    .module('branding')
    .service('brandModel', brandModel);

  function brandModel(bodyColorOptions) {

    // Code review notes from Max
    // remove setters

    var self = this;

    this.name = '';

    this.setName = function (value) {
      self.name = value;
    };


    this.description = '';

    this.setDescription = function (value) {
      self.description = value;
    };


    this.logoUrl = '';
    this.logoFileId = '';

    this.setLogoUrl = function (value) {
      self.logoUrl = value;
    };

    this.setLogoFileId = function (value) {
      self.logoFileId = value;
    };

    this.selectedBodyColor = '';

    this.getBodyColorOptions = function () {
      return bodyColorOptions;
    };

    this.setSelectedBodyColor = function (value) {
      self.selectedBodyColor = (_.findWhere(bodyColorOptions, {mtype: value}) || bodyColorOptions[0]).color;
    };


    this.selectedHeaderBackgroundColor = '#ffffff';

    this.setHeaderBackgroundColor = function (value) {
      if (value === undefined || value === null) {
        self.selectedHeaderBackgroundColor = '#ffffff';
      } else {
        self.selectedHeaderBackgroundColor = value;
      }
    };


    this.selectedTextColor = '#000000';

    this.setHeaderTextColor = function (value) {
      if (value === undefined || value === null) {
        self.selectedTextColor = '#000000';
      } else {
        self.selectedTextColor = value;
      }
    };


    this.selectedLinkColor = '#00aeef';

    this.setHeaderLinkColor = function (value) {
      if (value === undefined || value === null) {
        self.selectedLinkColor = '#00aeef';
      } else {
        self.selectedLinkColor = value;
      }
    };


    this.isValidLogo = function () {
      return self.logoFileId && self.logoUrl;
    };


    this.logoStatus = 'unchanged';

    this.setLogoStatus = function (value) {
      self.logoStatus = value;
    }
  }

})();
